export const HybridMobile = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="25"
    height="25"
    fill="none"
    stroke="black"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <rect x="16" y="8" width="32" height="48" rx="4" />
    <rect x="20" y="12" width="24" height="40" rx="4" />
    <circle cx="32" cy="50" r="2" />
  </svg>
);
